<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('Headers.sign')"></header-big>
      </v-col>
    </v-row>
    <revoke-dialog
      :dialog="revokeDialog"
      @cancel="revokeDialog = false"
    ></revoke-dialog>

    <v-row align="center">
      <v-col cols="12" sm="12" v-if="!mobile">
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step key="1-step" :complete="step > 1" step="1">{{
              $t("HomePage.header.credentials")
            }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step key="2-step" :complete="step > 2" step="2">{{
              $t("HomePage.header.check")
            }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              v-if="currentWorkflow.signer_type != 's_signature'"
              key="3-step"
              :complete="step > 3"
              step="3"
              >{{ $t("HomePage.header.authenticate") }}</v-stepper-step
            >
            <v-divider
              v-if="currentWorkflow.signer_type != 's_signature'"
            ></v-divider>
            <v-stepper-step
              key="4-step"
              :complete="step > 4"
              :step="currentWorkflow.signer_type != 's_signature' ? '4' : '3'"
              >{{ $t("HomePage.header.summary") }}</v-stepper-step
            >
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="12">
        <router-view @refuse="refuse" @step="updateStepper" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/i18n";
import HeaderBig from "../../components/ui/text/HeaderBig";
import Credentials from "./Credentials";
import Documents from "./Documents";
import WorkflowSummary from "../SummaryPage";
import RevokeDialog from "../../components/ui/input/RevokeDialog";
import AesAuthenticate from "./AesAuthenticateMainPage";
import QesIdentify from "./QesIdentify";

export default {
  name: "MainPage",
  title: i18n.t("Headers.sign"),
  components: {
    WorkflowSummary,
    HeaderBig,
    Credentials,
    Documents,
    RevokeDialog,
    AesAuthenticate,
    QesIdentify,
  },
  data() {
    return {
      step: 1,
      mobile: false,
      revokeDialog: false,
      aes: true,
    };
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
  },
  created() {
    this.mobile = this.$vuetify.breakpoint.mdAndDown;
  },
  methods: {
    navigate(val, aes = true) {
      this.step = val;
      this.aes = aes;
    },
    updateStepper(val) {
      this.step = val;
    },
    refuse() {
      this.revokeDialog = true;
    },
  },
};
</script>